<template>
  <div v-if="model.schedule">
    <page-header :title="$t('game.gallery')">
      <li class="breadcrumb-item">
        <router-link :to="{name:'photos'}">{{ $tc('photo', 2) }}</router-link>
      </li>
      <li class="breadcrumb-item">{{ model.homeTeam.name + ' : ' + model.awayTeam.name }}</li>
      <li class="breadcrumb-item">{{ $t('game.gallery') }}</li>
    </page-header>
    <page-content>
      <div class="mb-3">
        <h4 class="mb-1">{{ model.homeTeam.name }} : {{ model.awayTeam.name }}</h4>
        <div class="text-muted">
          <span v-if="gameTime"><i class="fa fa-calendar mr-1"></i>{{ $d(gameTime, 'dateLong') }}</span>
          <span v-if="model.schedule.name" class="ml-3"><i class="fa fa-trophy mr-1"></i>{{ model.schedule.name }}</span>
          <span v-if="model.venue && model.venue.name" class="ml-3"><i class="fa fa-map-marker mr-1"></i>{{ model.venue.name }}</span>
        </div>
      </div>
      <div class="block block-rounded">
        <ul class="nav nav-tabs nav-tabs-block" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              :class="{ active: activeTab === 'photos' }"
              role="tab"
              @click="activeTab = 'photos'"
            >
              <i class="fa fa-image mr-1"></i> {{ $t('game.gamePhotos') }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              :class="{ active: activeTab === 'players' }"
              role="tab"
              @click="activeTab = 'players'"
            >
              <i class="fa fa-users mr-1"></i> {{ $t('game.playerPhotos') }}
            </button>
          </li>
        </ul>
        <div class="block-content tab-content">
          <div class="tab-pane" :class="{ 'active show': activeTab === 'photos' }" role="tabpanel">
            <le-game-photo-gallery v-if="activeTab === 'photos'" :game-uuid="model.uuid"></le-game-photo-gallery>
          </div>
          <div class="tab-pane" :class="{ 'active show': activeTab === 'players' }" role="tabpanel">
            <le-gallery-players v-if="activeTab === 'players'" :game-uuid="model.uuid"></le-gallery-players>
          </div>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import LeGamePhotoGallery from '@/components/le/LeGamePhotoGallery.vue'
import LeGalleryPlayers from '@/components/le/LeGalleryPlayers.vue'
import GamePhotosService from '@/services/gamePhotos.service'
import { useRouteQuery } from '@/use/useRouteQuery'
import { parseGameTime } from '@/lib/dateTime'

export default {
  components: {
    LeGamePhotoGallery,
    LeGalleryPlayers
  },
  setup () {
    const activeTab = useRouteQuery('tab', 'photos')
    return { activeTab }
  },
  data () {
    return {
      model: {
        schedule: null,
        round: null,
        homeTeam: null,
        awayTeam: null
      }
    }
  },
  computed: {
    gameTime () {
      const time = this.model.time
      return parseGameTime(time)
    }
  },
  methods: {
    setData (data) {
      this.model = data
    }
  },
  beforeRouteEnter (to, from, next) {
    GamePhotosService.show(to.params.game).then((response) => {
      next(vm => vm.setData(response.data))
    })
  }
}
</script>
